module.exports = __webpack_public_path__ + "static/chardalyn_berserker-5c5265aaedeb90ce9b0ba31eb8e55a92.jpeg";